export const zakladki = {
  zakladki: {
    "@ile": "5",
    items: [
      {
        "@ile": "1",
        item: [
          {
            nazwa: "Chiny wycieczki",
            pozycja: "1-A",
            link: "/",
            geourl: [],
            target: [],
            follow: []
          },
          {
            nazwa: "Promocje",
            pozycja: "1-B",
            link: "/oferta/szukaj.xml?extern=1&promocje=1",
            geourl: [],
            target: [],
            follow: []
          },
          {
            nazwa: "Wycieczki objazdowe",
            pozycja: "1-C",
            link: "/rodzaj-oferty/wycieczki-objazdowe.xml",
            geourl: [],
            target: [],
            follow: []
          },
          {
            nazwa: "Więcej",
            pozycja: "1-D",
            link: "/rodzaj-oferty.xml",
            geourl: [],
            target: [],
            follow: []
          }
        ]
      },
      {
        "@ile": "2",
        item: [
          {
            nazwa: "Przewodnik",
            pozycja: "2-A",
            link: "/chiny-przewodnik-turystyczny.xml",
            geourl: "1",
            target: [],
            follow: []
          },
          {
            nazwa: "Przewodnik Chiny",
            pozycja: "2-B",
            link: "/chiny-przewodnik-turystyczny.xml",
            geourl: "1",
            target: [],
            follow: []
          },
          {
            nazwa: "Chiny Północne",
            pozycja: "2-C",
            link: "/chiny-polnocne.xml",
            geourl: "1",
            target: [],
            follow: []
          },
          {
            nazwa: "Chiny Wschodnie",
            pozycja: "2-D",
            link: "/chiny-wschodnie.xml",
            geourl: "1",
            target: [],
            follow: []
          },
          {
            nazwa: "Chiny  Południowe",
            pozycja: "2-E",
            link: "/chiny-poludniowe.xml",
            geourl: "1",
            target: [],
            follow: []
          },
          {
            nazwa: "Chiny Centralne",
            pozycja: "2-F",
            link: "/chiny-centralne.xml",
            geourl: "1",
            target: [],
            follow: []
          },
          {
            nazwa: "Tybet",
            pozycja: "2-G",
            link: "/tybet.xml",
            geourl: "1",
            target: [],
            follow: []
          },
          {
            nazwa: "Wyspa Tajwan",
            pozycja: "2-H",
            link: "/wyspa-tajwan.xml",
            geourl: "1",
            target: [],
            follow: []
          }
        ]
      },
      {
        "@ile": "7",
        item: [
          {
            nazwa: "Wczasy w Polsce",
            pozycja: "7-A",
            link: "https://www.polska.travelone.pl",
            geourl: [],
            target: [],
            follow: []
          }
        ]
      },
      {
        "@ile": "8",
        item: [
          {
            nazwa: "Podróże po Świecie",
            pozycja: "8-A",
            link: "https://www.podroze.travelone.pl",
            geourl: [],
            target: [],
            follow: []
          }
        ]
      },
      /*{
          "@ile": "4",
          "item": [
            {
              "nazwa": "Hotele",
              "pozycja": "4-A",
              "link": "www.hotele.chiny.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Pekin",
              "pozycja": "4-B",
              "link": "www.hotele.chiny.com.pl/?id=pekin",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Shanghai",
              "pozycja": "4-C",
              "link": "www.hotele.chiny.com.pl/?id=shanghai",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Więcej",
              "pozycja": "4-D",
              "link": "www.hotele.chiny.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            }
          ]
        },*/
      {
        "@ile": "5",
        item: [
          {
            nazwa: "Pogoda i klimat",
            pozycja: "5-B",
            link: "/pogoda-klimat.xml",
            geourl: [],
            target: [],
            follow: []
          },
          {
            nazwa: "Kiedy jechać",
            pozycja: "5-C",
            link: "/pogoda-klimat.xml?&p=kiedy-jechac",
            geourl: [],
            target: [],
            follow: []
          }
        ]
      }
    ]
  }
};
